<template>
  <div>
    <ts-card-wrapper class="no-padding-top">
      <div class="d-flex justify-content-between">
        <div class="ts-flex ts-items-center ts-space-x-3">
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('luckyDrawReward.dateRange')
              }}</label>
              <br />
              <a-range-picker
                v-model="dateRange"
                format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"
                style="width: 200px"
                @change="fetchData()"
              />
            </div>
          </div>
          <!-- close for now -->
          <div class="row" v-if="false">
            <div>
              <label class="ts-text-xs">{{
                $t('luckyDrawReward.event')
              }}</label>
              <br />
              <a-select
                style="width: 300px"
                v-model="event_id"
                :options="eventLists"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
                :maxTagTextLength="17"
                :placeholder="$t('all')"
                @change="fetchData()"
              ></a-select>
            </div>
          </div>
          <div class="row">
            <div>
              <label class="ts-text-xs">{{
                $t('luckyDrawReward.isSpinned')
              }}</label>
              <br />
              <a-select
                v-model="is_spinned"
                :options="isSpinneList"
                style="width: 200px"
                placeholder="All"
                @change="fetchData()"
              ></a-select>
            </div>
          </div>
          <div class="row">
            <div>
              <label class="ts-text-xs">{{ $t('excel') }}</label>
              <br />
              <div>
                <ts-button
                  class="btn-block"
                  outline
                  color="success"
                  @click.prevent="exportExcel"
                  :waiting="exporting"
                  ><i class="fas fa-file-excel"></i>
                  {{ $t('excel') }}</ts-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex ts-space-x-3">
          <ts-input
            v-tooltip="$t('luckyDrawReward.search')"
            v-model="search"
            :placeholder="$t('luckyDrawReward.search')"
            style="width: 250px"
            class="inline-block"
          />
          <ts-filter ref="filter">
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="">{{ $t('employeeProfile.branch') }}</label>
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :placeholder="$t('all')"
                  @change="changeBranch()"
                >
                </a-select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="">{{ $t('wholesaleReceipt.warehourse') }}</label>
                <a-select
                  style="width: 257px"
                  v-model="location_id"
                  :options="locations"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <label class="">{{ $t('luckyDrawReward.sale') }}</label>
                <a-select
                  style="width: 257px"
                  v-model="sale_id"
                  :options="saleList"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                  @change="fetchData()"
                ></a-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="">{{ $t('luckyDrawReward.item') }}</label>
                <a-select
                  v-model="item_id"
                  :options="itemList"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                  style="width: 257px"
                  @change="fetchData()"
                ></a-select>
              </div>
            </div>
          </ts-filter>
        </div>
      </div>
    </ts-card-wrapper>
    <ts-loading-banner :loading="loading">
      <div class="ts-overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-text-center">
              {{ record.display_order }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.event_name }}
            </td>
            <td>
              {{ record.item_name_en }}
            </td>
            <td class="ts-text-center">
              <span class="badge badge-success" v-if="record.is_spinned"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </td>
            <td>
              {{ record.modified }}
            </td>
            <td>{{ record.win_id_number }}</td>
            <td>
              {{ record.id_name }}
            </td>
            <td>{{ record.win_serial_no }}</td>
            <td>
              {{ record.imei }}
            </td>
            <td>
              {{
                record.is_spinned
                  ? record.fee_amount + record.currency_code
                  : ''
              }}
            </td>
            <td>{{ record.sale_name }}</td>
            <td>
              {{ record.branch_name_en }}
            </td>
            <td>
              {{ record.location_name_en }}
            </td>
            <td class="text-center">
              <a
                v-if="!record.is_spinned"
                href="#"
                v-tooltip="$t('luckyDrawReward.changeDisplayOrder')"
                class="text-primary"
                @click.prevent="changeDisplayOrder(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('luckyDrawReward.changeDisplayOrder')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
      >
        <from-action @cancel="clearEdit" />
      </a-modal>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim } from 'lodash'
import FromAction from './form'

export default {
  name: 'currentEvent',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false,
      exporting: false
    }
  },

  computed: {
    ...mapState('luckyDraw/luckyDrawReward', [
      'resources',
      'pagination',
      'formViewData'
    ]),
    search: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.search
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_SEARCH', newValue)
        this.$store.commit('luckyDraw/luckyDrawReward/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          name: this.$t('luckyDrawReward.no'),
          style: 'text-align: center;'
        },
        { name: this.$t('luckyDrawReward.event') },
        { name: this.$t('luckyDrawReward.itemNameEn') },
        {
          name: this.$t('luckyDrawReward.isSpinned'),
          style: 'text-align: center;'
        },
        { name: this.$t('luckyDrawReward.drawDate') },
        { name: this.$t('luckyDrawReward.idNumber') },
        { name: this.$t('luckyDrawReward.customer') },
        { name: this.$t('luckyDrawReward.serialNo') },
        { name: this.$t('luckyDrawReward.phoneNumber') },
        { name: this.$t('luckyDrawReward.amountPaid') },
        { name: this.$t('luckyDrawReward.sale') },
        { name: this.$t('luckyDrawReward.branch') },
        { name: this.$t('luckyDrawReward.warehourse') },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    },
    event_id: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.event_id
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_EVENT_ID', newValue)
      }
    },
    eventLists () {
      if (!this.formViewData.LuckyDrawAvailableItem) return []
      return this.formViewData.LuckyDrawAvailableItem.map(el => ({
        value: el.id,
        label: el.event_name
      }))
    },
    saleList () {
      if (!this.formViewData.users) return []
      return this.formViewData.users.map(el => ({
        value: el.user_id,
        label: el.name
      }))
    },
    itemList () {
      if (!this.formViewData.itemList) return []
      return this.formViewData.itemList.map(el => ({
        value: el.item_id,
        label: el.item_name_en
      }))
    },
    is_spinned: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.is_spinned
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_IS_SPINNED', newValue)
      }
    },
    isSpinneList () {
      return [
        { value: 0, label: 'All' },
        { value: 1, label: 'Is Spinned' },
        { value: 2, label: 'Not Spinned' }
      ]
    },
    dateRange: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.dateRange
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_DATE_RANGE', newValue)
      }
    },
    location_id: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.location_id
      },
      set (newValue) {
        this.$store.commit(
          'luckyDraw/luckyDrawReward/SET_LOCATION_ID',
          newValue
        )
      }
    },
    branch_id: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.branch_id
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_BRANCH_ID', newValue)
      }
    },
    sale_id: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.sale_id
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_SALE_ID', newValue)
      }
    },
    item_id: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.item_id
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_ITEM_ID', newValue)
      }
    },
    locations: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.locations
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_LOCATIONS', newValue)
      }
    },
    branchs: {
      get () {
        return this.$store.state.luckyDraw.luckyDrawReward.branchs
      },
      set (newValue) {
        this.$store.commit('luckyDraw/luckyDrawReward/SET_BRANCHS', newValue)
      }
    }
  },
  methods: {
    async changeBranch () {
      this.loading = true
      this.location_id = []
      await this.$store
        .dispatch('security/user/getWarehouseAssignedForFilter', {
          branch_id: this.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeDisplayOrder (record) {
      this.$store.commit('luckyDraw/luckyDrawReward/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit () {
      this.$store.commit('luckyDraw/luckyDrawReward/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    },
    async fetchData (attributes) {
      this.loading = true
      await this.$store.commit('luckyDraw/luckyDrawReward/SET_REPORT_TYPE', 1)
      await this.$store.commit(
        'luckyDraw/luckyDrawReward/SET_EVENT_ID',
        undefined
      )

      await this.$store
        .dispatch('luckyDraw/luckyDrawReward/fetch', {
          ...attributes
        })
        .then(() => {})
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('luckyDraw/luckyDrawReward/exportExcel')
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    },
    notice (not) {
      this.$Notice[not.type]({
        title: 'Product Addon Info',
        desc: not.text
      })
    }
  }
}
</script>
<style scoped>
.no-padding-top {
  padding: 0 1rem 1rem 1rem;
}
</style>
